import { useClearCursorOnSelection } from '../hooks/cursor/useClearCursorOnSelection';
import { useStreamHotkeysCore } from '../hooks/hotkeys/useStreamHotkeysCore';
import { useClearSelectionOnRangeChange } from '../hooks/selection/useClearSelectionOnRangeChange';
import { useAutoOpenFragmentDrawer } from './focus/selection/useAutoOpenFragmentDrawer';

/**
 * Component that handles global hooks for the Logger Stream Screen.
 * This component doesn't render anything, it only executes hooks.
 * Runs inside Page so drawer context is available (e.g. for open-fragment hotkey).
 */
export function LoggerScreenSetup() {
  useStreamHotkeysCore();
  useClearCursorOnSelection();
  useAutoOpenFragmentDrawer();
  useClearSelectionOnRangeChange();

  return null;
}
